// extracted by mini-css-extract-plugin
export default {"wrapper":"Input_wrapper__K8e8w","label-wrapper":"Input_label-wrapper__dU1qp"};